import React from 'react';
import { Container, Grid, Box, Typography, Button, Chip } from '@mui/material';
import { Phone, WhatsApp } from '@mui/icons-material';

export const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                py: 8,
                background: 'rgba(255, 255, 255, 0.7)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                borderTop: '1px solid rgba(91, 76, 219, 0.15)',
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    <Grid size={{ xs: 12, md: 7 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                            <img
                                src="/logo.png"
                                alt="Myl Logo"
                                style={{
                                    width: '60px',
                                    height: '60px',
                                    objectFit: 'contain',
                                }}
                            />
                            <Typography
                                variant="h4"
                                sx={{
                                    fontWeight: 700,
                                    background: 'linear-gradient(135deg, #5b4cdb 0%, #06b6d4 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            >
                                Myl
                            </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ mb: 2, color: '#64748b' }}>
                            11+ Coaching in Maths, English, Verbal Reasoning and Non-Verbal Reasoning.
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 3 }}>
                            <Chip label="Small groups" size="small" />
                            <Chip label="Personalised learning" size="small" />
                            <Chip label="Mock exams" size="small" />
                            <Chip label="Regular feedback" size="small" />
                        </Box>
                        <Typography variant="body2" sx={{ color: '#64748b' }}>
                            © {currentYear} Myl . All rights reserved.
                        </Typography>
                    </Grid>

                    <Grid size={{ xs: 12, md: 5 }}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
                            Quick Contact
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 3, color: '#64748b' }}>
                            <strong>Call/WhatsApp:</strong> +44 7459 240172
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                            <Button
                                variant="outlined"
                                startIcon={<Phone />}
                                href="tel:+447459240172"
                            >
                                Call
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<WhatsApp />}
                                href="https://wa.me/447459240172"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                WhatsApp
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};
